import React from 'react'

import type { PromotionPopups, createPopupsStore } from './store'

export type PopupsContextProps<
  T extends PromotionPopups = Record<string, any>,
> = ReturnType<typeof createPopupsStore<T>>

export const PopupsContext = React.createContext<PopupsContextProps>(null!)
